import { colorTokenMap, GDSColorToken } from '@leagueplatform/genesis-core';

/**
 * Maps a GDSColorToken string to its corresponding GDSColor value.
 * Used to convert Masonry token references to Genesis color values.
 */
export const mapIconTintToken = <T extends { iconTint?: GDSColorToken }>(
  item: T,
) => ({
  ...item,
  iconTint: item.iconTint ? colorTokenMap[item.iconTint] : undefined,
});
